<template>
  <div>
    <div class="fix-height row excel-upload-cover">
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
        <q-uploader
          flat
          bordered
          with-credentials
          ref="excelUpload"
          class="excel-upload"
          capture="environment"
          field-name="file"
          method="POST"
          label="Excel 업로드"
          :auto-upload="false"
          :hide-upload-btn="true"
          :multiple="false"
          accept="xlsx"
          :max-file-size="100000000"
          :max-total-size="100000000"
          :max-files="1"
          :no-thumbnails="false"
          :disable="!excelEditable || isValidating"
          :style="maxheight"
          @rejected="rejected"
          @added="added"
        >
          <template v-slot:header="scope">
            <div class="row no-wrap items-center q-pa-none">
              <q-spinner v-if="scope.isUploading || isValidating" class="q-uploader__spinner" />
              <div class="col" style="padding-top: 0px !important; margin-top: 0px !important">
                <div
                  class="q-uploader__title inline-block"
                  style="padding: 4px 0px !important; font-size: 0.95em !important"
                >
                  Excel 업로드
                </div>
                &nbsp;&nbsp;
                <div class="q-uploader__subtitle inline-block" v-if="excelEditable">
                  {{ scope.uploadSizeLabel }} / {{ scope.uploadProgressLabel }}
                </div>
              </div>
              <q-btn
                v-if="excelEditable && isTemplateDown"
                class="excel-upload-btn"
                icon="file_download"
                dense
                outline
                size="sm"
                label="양식 다운로드"
                @click="downTemplate"
              />
              <q-btn
                v-if="scope.queuedFiles.length > 0 && excelEditable"
                class="excel-upload-btn"
                icon="delete"
                dense
                outline
                size="sm"
                label="파일 삭제"
                @click="deleteFile"
              />
            </div>
          </template>
          <template v-slot:list="scope">
            <template v-if="scope.files && scope.files.length > 0">
              <q-list separator>
                <q-item v-for="file in scope.files" :key="file.name">
                  <q-item-section>
                    <q-item-label class="full-width ellipsis">
                      {{ file.name }}
                    </q-item-label>
                    <q-item-label caption> Status: {{ file.__status }} </q-item-label>
                    <q-item-label caption>
                      {{ file.__sizeLabel }} / {{ file.__progressLabel }}
                    </q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </template>
            <template v-else>
              <div class="empty_dscription">
                <div style="text-align: center; padding-bottom: 5px" v-show="excelEditable">
                  <q-chip outline square icon="info" style="width: 100%"> Drag or Click </q-chip>
                </div>
                <div class="q-pl-md txtfileinfo" style="text-align: left">
                  <span class="text-positive">
                    업로드 가능 확장자
                  </span>
                  : xlsx
                  <br />
                  <span class="text-positive">
                    업로드 가능 파일 수
                  </span>
                  : 1
                  <br />
                  <span class="text-positive">
                    허용 파일 크기
                  </span>
                  : 100MB
                </div>
                <q-uploader-add-trigger />
              </div>
            </template>
          </template>
        </q-uploader>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
        <c-card
          title="업로드 현황"
          class="cardClassDetailForm excel-upload-status-card"
          height="164px"
        >
          <template v-slot:card-button>
            <q-btn-group outline v-if="excelEditable">
              <c-btn
                label="업로드 완료"
                icon="check"
                :disabled="isValidating || isSaving"
                @btnClicked="saveUpload(true)"
              />
            </q-btn-group>
          </template>
          <template v-slot:card-detail>
            <q-inner-loading :showing="isValidating">
              <q-spinner-ball class="regul-db-spinner" size="3em" />
            </q-inner-loading>
            <span
              class="text-grey-9 q-pa-sm"
              style="font-size: 0.95em"
              v-html="$comm.convertEnter(uploadMessage)"
            />
          </template>
        </c-card>
      </div>
      <div class="col-12">
        <c-tab
          type="tabcard"
          align="left"
          :tabItems="tabItems"
          :inlineLabel="true"
          :height="tabHeight"
          v-model="tab"
        >
          <template v-slot:default="tab">
            <c-table
              ref="excelUploadTable"
              title="Excel 검증 결과 목록"
              :editable="excelEditable"
              :columns="columns[Number(tab.name)]"
              :data="filteredRows(Number(tab.name))"
              :gridHeight="gridHeight"
              :isExpand="true"
              :usePaging="false"
              :selection="excelEditable ? 'multiple' : 'none'"
              :rowKey="excelUploadInfo.rowKeys[Number(tab.name)]"
              :customTrClass="setTrClass"
            >
              <template v-slot:table-chip>
                <span
                  v-if="newChemRows.length > 0"
                  class="q-ml-lg text-deep-purple"
                  style="font-size: 0.94em"
                >
                  ✔️ 기존 화학물질에 없는 건은 오렌지색으로 표시되며, 다음 단계에서 규제 적용 시
                  화학물질에 신규로 등록됩니다. (총
                  {{ newChemRows.length }} 건)
                  <q-chip
                    outline
                    square
                    clickable
                    size="12px"
                    color="orange"
                    class="q-ml-sm"
                    :label="newChemOnly ? '전체보기' : '신규 물질만 보기'"
                    @click="newChemOnly = !newChemOnly"
                  />
                </span>
              </template>
              <template v-slot:table-button>
                <q-btn-group outline>
                  <c-btn
                    v-if="
                      excelUploadInfo.data[Number(tab.name)] &&
                      excelUploadInfo.data[Number(tab.name)].length > 0 &&
                      excelEditable
                    "
                    :label="!errorDataCheck ? '에러 데이터만 확인' : '전체보기'"
                    icon="find_in_page"
                    @btnClicked="errorDataCheck = !errorDataCheck"
                  />
                  <c-btn
                    v-if="
                      excelUploadInfo.data[Number(tab.name)] &&
                      excelUploadInfo.data[Number(tab.name)].length > 0 &&
                      excelEditable
                    "
                    label="제외"
                    icon="remove"
                    @btnClicked="removeData(tab.name)"
                  />
                </q-btn-group>
              </template>
              <template v-slot:expand-header>
                에러 상세
              </template>
              <template v-slot:expand-td="props">
                <c-card class="excel-upload-status-card" :noHeader="true">
                  <template v-slot:card-detail>
                    <div class="col-12">
                      <span v-html="$comm.convertEnter(props.row.error_message)" />
                    </div>
                  </template>
                </c-card>
              </template>
            </c-table>
          </template>
        </c-tab>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar'
import XLSX from 'xlsx'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
import { encrypt, fileDownDecrypt } from '@/js/aes256';

const EXPECTED_EXCEL_HEADERS = [
  '규제법규 구분',
  '규제항목 구분',
  '위안법 세부분류',
  '삭제여부',
  'CAS No.',
  '국문명',
  '영문명',
  '성질',
  '품명',
  '부등호',
  '정량값/함유량',
  '규정수량/취급량/지정수량',
  '단위',
  'TWA(ppm)',
  'TWA(mg/㎥)',
  'STEL(ppm)',
  'STEL(mg/㎥)',
  '비고',
  '고시번호',
  '고시내용',
  '적용기준',
  '고시일자',
  '고유번호',
];

export default {
  name: 'chemUpdateDbUploadExcel',
  props: {
    param: {
      type: Object,
      default: () => ({
        mdmMaterialRegulatoryInfoExcelUploadId: '',
        stepCd: 'CUED000001',
        statusCd: 'CEUS000001',
        searchProcess: { flag: '', isSearch: false },
      }),
    },
    height: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      editable: true,
      isTemplateDown: true,
      isValidating: false,
      isSaving: false,
      errorDataCheck: false,
      newChemOnly: false,
      maxheight: 'max-height:200px;min-height:200px;width: 100%;',
      tab: 0,
      isError: false,
      uploadMessage: '',
      fileInfo: {
        oriFileNm: '',
        fileExt: '',
      },
      popupOptions: {
        width: '100%',
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
      regulDbUpload: {
        details: [],
      },
      excelUploadInfo: {
        rowKeys: ['rowKey'],
        taskClassCd: 'CHEM_REGUL',
        sheetNum: 0,
        columns: [],
        data: [],
      },
      templateColName: [],
      templateHeader: [],
      sheetNames: [],
      templateExcelFileUrl: '',
      fileInfoUrl: '',
      validExcelUrl: '',
      saveExcelUrl: '',
      completeExcelUrl: '',
      detailExcelUrl: '',
    };
  },
  computed: {
    // 상단 업로드 영역(약 220px)을 제외한 나머지 높이를 탭에 할당
    tabHeight() {
      const numHeight = this.height ? Number(String(this.height).replace('px', '')) : 0;
      return numHeight > 0 ? String(numHeight - 270) + 'px' : '400px';
    },
    // 탭 헤더/테이블 타이틀 영역을 제외한 그리드 높이
    gridHeight() {
      const numHeight = Number(this.tabHeight.replace('px', ''));
      return numHeight > 0 ? String(numHeight - 10) + 'px' : '400px';
    },
    // 엑셀 업로드 단계(CEUS000001)에서만 파일/제외 등 수정 가능
    excelEditable() {
      return this.editable && this.param.statusCd === 'CEUS000001';
    },
    newChemRows() {
      return (this.excelUploadInfo.data[0] || []).filter(
        (item) => (Boolean(item.casNo) && !item.mdmChemId) || item.newChemFlag === 'Y'
      );
    },
    columns() {
      return this.excelUploadInfo.columns.map((sheetColumns) => {
        const result = [
          {
            name: 'rowIndex',
            field: 'rowIndex',
            label: '행',
            align: 'center',
            style: 'width:60px',
            sortable: false,
          },
        ];
        this.$_.forEach(sheetColumns, (item) => {
          result.push({
            name: item.name,
            field: item.name,
            label: item.label,
            align: item.align || 'left',
            style: item.style,
            sortable: false,
          });
        });
        return result;
      });
    },
    tabItems() {
      return this.sheetNames.map((sheet, idx) => ({
        name: idx,
        label: sheet,
      }));
    },
  },
  watch: {
    'param.searchProcess.flag'() {
      if (this.param.mdmMaterialRegulatoryInfoExcelUploadId) this.getSavedUpload();
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.templateExcelFileUrl = selectConfig.sys.excelUpload.template.url;
      this.fileInfoUrl = selectConfig.com.upload.fileInfo.url;
      this.validExcelUrl = transactionConfig.chm.regul.updateData.excelValid.url;
      this.saveExcelUrl = transactionConfig.chm.regul.updateData.excelUpload.save.url;
      this.completeExcelUrl = transactionConfig.chm.regul.updateData.excelUpload.complete.url;
      this.detailExcelUrl = selectConfig.chm.regul.updateData.excelUpload.get.url;
      this.setDefaultColumns();
      this.getFileInfo();
      this.getExcelTemplateHeader();
      if (this.param.mdmMaterialRegulatoryInfoExcelUploadId) this.getSavedUpload();
    },
    /**
     * 엑셀파일 양식 정보 조회
     */
    getFileInfo() {
      if (!this.excelUploadInfo.taskClassCd) return;
      this.$http.url = this.fileInfoUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        taskClassCd: 'EXCEL_UPLOAD_TEMPLATE',
        taskKey: this.excelUploadInfo.taskClassCd,
      };
      this.$http.request((_result) => {
        this.fileInfo = _result.data;
      });
    },
    /**
     * 엑셀업로드 기본 컬럼 설정
     */
    setDefaultColumns() {
      this.excelUploadInfo.columns = [
        [
          {
            fix: true,
            name: 'regulationBillName',
            label: '규제법규 구분',
            align: 'center',
            style: 'width:160px',
          },
          {
            fix: true,
            name: 'regulatedItemName',
            label: '규제항목 구분',
            align: 'center',
            style: 'width:160px',
          },
          { name: 'dangerItemName', label: '위안법 세부분류', align: 'left', style: 'width:160px' },
          { name: 'deleteFlag', label: '삭제여부', align: 'center', style: 'width:60px' },
          { name: 'casNo', label: 'CAS No.', align: 'center', style: 'width:120px' },
          { name: 'chemNmKr', label: '국문명', align: 'left', style: 'width:180px' },
          { name: 'chemNmEn', label: '영문명', align: 'left', style: 'width:200px' },
          {
            name: 'dangerousProp',
            label: '성질',
            align: 'left',
            style: 'width:130px',
            type: 'text',
          },
          {
            name: 'dangerousName',
            label: '품명',
            align: 'left',
            style: 'width:150px',
            type: 'text',
          },
          { name: 'appliStandSign', label: '부등호', align: 'center', style: 'width:60px' },
          { name: 'appliStandQuantity', label: '정량값/함유량', align: 'right', style: 'width:130px' },
          {
            name: 'regulationQuantityDose',
            label: '규정수량/취급량/지정수량',
            align: 'right',
            style: 'width:160px',
          },
          { name: 'appliStandUnit', label: '단위', align: 'center', style: 'width:70px' },
          {
            name: 'twaPpm',
            label: 'TWA(ppm)',
            align: 'right',
            style: 'width:90px',
            type: 'text',
          },
          {
            name: 'twaMm',
            label: 'TWA(mg/㎥)',
            align: 'right',
            style: 'width:110px',
            type: 'text',
          },
          {
            name: 'stelPpm',
            label: 'STEL(ppm)',
            align: 'right',
            style: 'width:90px',
            type: 'text',
          },
          {
            name: 'stelMm',
            label: 'STEL(mg/㎥)',
            align: 'right',
            style: 'width:110px',
            type: 'text',
          },
          {
            name: 'designatedQuantityRemark',
            label: '비고',
            align: 'left',
            style: 'width:120px',
            type: 'text',
          },
          { name: 'notiNo', label: '고시번호', align: 'left', style: 'width:200px' },
          { name: 'notice', label: '고시내용', align: 'left', style: 'width:240px' },
          { name: 'appliStandContents', label: '적용기준', align: 'center', style: 'width:160px' },
          { name: 'notiDt', label: '고시일자', align: 'center', style: 'width:100px' },
          { name: 'uniqNo', label: '고유번호', align: 'center', style: 'width:100px' },
        ],
      ];
    },
    /**
     * 엑셀 양식 확인
     */
    getExcelTemplateHeader() {
      this.$http.url = this.templateExcelFileUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        taskClassCd: encrypt(this.excelUploadInfo.taskClassCd),
      };
      this.$http.request((_result) => {
        const fileInfoData = fileDownDecrypt(_result.data);
        if (fileInfoData.id === this.excelUploadInfo.taskClassCd) {
          const cfb = XLSX.read(fileInfoData.bytes, { type: 'base64' });
          const sheetNum = 0;
          this.sheetNames = [cfb.SheetNames[sheetNum]];
          this.templateHeader = [EXPECTED_EXCEL_HEADERS];
          this.templateColName = XLSX.utils.sheet_to_json(cfb.Sheets[cfb.SheetNames[sheetNum]], {
            raw: false,
          })[0];
        } else {
          window.getApp.$emit('ALERT', {
            title: '안내',
            message: '잘못된 정보입니다.',
            type: 'error',
          });
        }
      });
    },
    /**
     * 업로드 파일 거부
     */
    rejected(info) {
      if (!info || info.length === 0) {
        return;
      }
      this.clearUploadData();
      this.$_.forEach(info, (reject) => {
        switch (reject.failedPropValidation) {
          case 'max-file-size':
          case 'max-total-size':
            this.isError = true;
            this.uploadMessage +=
              reject.file.name +
              ' > ' +
              '첨부하신 해당 파일의 용량이 지정된 용량보다 큽니다. 파일 용량 : ' +
              this.$comm.bytesToSize(reject.file.size);
            break;
          case 'max-files':
            this.isError = true;
            this.uploadMessage = '첨부하신 파일의 지정된 업로드 갯수를 초과하였습니다.';
            break;
          case 'accept':
            this.isError = true;
            this.uploadMessage = '첨부하신 파일의 확장자가 올바르지 않습니다.';
            break;
          default:
            break;
        }
      });
    },
    /**
     * 업로드 파일 등록 및 유효성 검증
     */
    added(files) {
      // 다음 단계 이후에는 업로드 불가
      if (!this.excelEditable) return;
      this.clearUploadData();
      const thisVue = this;
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = function () {
        const result = String(reader.result);
        const base64Data = result.replace('data:' + files[0].type + ';base64,', '');
        const cfb = XLSX.read(base64Data, {
          type: 'base64',
          cellDates: true,
          dateNF: 'YYYY-MM-DD',
        });

        const sheetNum = 0;
        if (!thisVue.templateHeader[sheetNum] || thisVue.templateHeader[sheetNum].length === 0) {
          thisVue.isError = true;
          thisVue.uploadMessage = '엑셀 양식 정보를 불러오는 중입니다. 잠시 후 다시 업로드 해주십시오.';
          return;
        }
        const uploadExcel = {
          header: thisVue.$comm.getHeaders(cfb.Sheets[cfb.SheetNames[sheetNum]]),
          data: XLSX.utils.sheet_to_json(cfb.Sheets[cfb.SheetNames[sheetNum]], {
            raw: false,
            dateNF: 'YYYY-MM-DD',
          }),
        };

        const headerCheck =
          uploadExcel.header.length === thisVue.templateHeader[sheetNum].length &&
          thisVue.templateHeader[sheetNum].every((item, idx) => uploadExcel.header[idx] === item);
        if (!headerCheck) {
          thisVue.isError = true;
          thisVue.uploadMessage = '업로드한 엑셀의 헤더가 올바르지 않습니다. 양식 다운로드하여 확인바랍니다.';
          return;
        }

        const mappingRowRemoved = thisVue.isTemplateMappingRow(uploadExcel.data[0]);
        const rows = thisVue.mapExcelRows(
          mappingRowRemoved ? uploadExcel.data.slice(1) : uploadExcel.data,
          mappingRowRemoved ? 3 : 2
        );
        if (rows.length === 0) {
          thisVue.isError = true;
          thisVue.uploadMessage = '업로드한 엑셀에 데이터가 없습니다. 확인 후 업로드 해주십시오.';
          return;
        }
        thisVue.validExcelRows(rows);
      };
    },
    /**
     * 엑셀 row를 API 요청 row로 변환
     */
    mapExcelRows(uploadRows, startRowIndex) {
      const rows = [];
      const sheetColumns = this.excelUploadInfo.columns[0] || [];
      this.$_.forEach(uploadRows, (data, idx) => {
        const pushData = {
          rowKey: uid(),
          rowIndex: idx + (startRowIndex || 2),
          error_message: '',
        };

        this.$_.forEach(sheetColumns, (column) => {
          pushData[column.name] = this.getExcelCellValue(data, [column.label, column.name]);
        });

        if (this.templateColName && Object.keys(this.templateColName).length > 0) {
          for (const colKey in this.templateColName) {
            const fieldName = this.templateColName[colKey];
            if (fieldName) pushData[fieldName] = data[colKey] === undefined || data[colKey] === null ? '' : data[colKey];
          }
        }
        rows.push(pushData);
      });
      return rows;
    },
    /**
     * 엑셀 첫 row가 필드명 매핑 row인지 확인
     */
    isTemplateMappingRow(row) {
      const sheetColumns = this.excelUploadInfo.columns[0] || [];
      const fieldNames = this.$_.map(sheetColumns, (column) => column.name);
      const rowValues = Object.keys(row || {}).map((key) => row[key]);
      return this.$_.filter(rowValues, (value) => fieldNames.includes(value)).length >= 2;
    },
    /**
     * 엑셀 cell 값 조회
     */
    getExcelCellValue(row, keys) {
      const findKey = keys.find((key) => row && row[key] !== undefined);
      return findKey !== undefined ? row[findKey] : '';
    },
    /**
     * 백엔드 API를 통한 엑셀 데이터 유효성 검증
     */
    validExcelRows(rows) {
      this.isValidating = true;
      this.uploadMessage = '유효성 검증 중입니다...';
      this.$http.url = this.validExcelUrl;
      this.$http.type = 'POST';
      this.$http.param = {
        rows,
      };
      this.$http.request(
        (_result) => {
          const resultRows = this.$_.map(_result.data || [], (row) => {
            row.rowKey = row.rowKey || uid();
            row.error_message = row.failContents || '';
            return row;
          });
          this.regulDbUpload.details = resultRows;
          this.excelUploadInfo.data = [resultRows];
          this.setUploadMessage();
          this.isValidating = false;
        },
        () => {
          this.isError = true;
          this.uploadMessage = '유효성 검증 중 에러가 발생하였습니다. 담당자에게 문의 바랍니다.';
          this.isValidating = false;
        }
      );
    },
    /**
     * 저장된 엑셀 업로드 상세 재조회
     */
    getSavedUpload() {
      if (!this.param.mdmMaterialRegulatoryInfoExcelUploadId) return;
      this.$http.url = this.$format(this.detailExcelUrl, this.param.mdmMaterialRegulatoryInfoExcelUploadId);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        const data = _result.data;
        const rows = (data.details || []).map((row, index) =>
          Object.assign({}, row, {
            rowKey: row.rowKey || uid(),
            rowIndex: row.rowIndex || index + 2,
            error_message: '',
          })
        );
        this.sheetNames = this.sheetNames.length > 0 ? this.sheetNames : ['업로드양식'];
        this.regulDbUpload.details = rows;
        this.excelUploadInfo.data = [rows];
        this.setUploadMessage();
      });
    },
    /**
     * 정상 데이터 임시저장 또는 완료
     */
    saveUpload(complete) {
      // 엑셀 업로드 단계에서만 저장/완료 가능
      if (!this.excelEditable) return;
      const rows = this.excelUploadInfo.data[0] || [];
      const normalRows = rows.filter((row) => !row.error_message);
      const errorRows = rows.filter((row) => Boolean(row.error_message));
      if (normalRows.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내',
          message: '저장할 정상 데이터가 없습니다.',
          type: 'warning',
        });
        return;
      }

      if (errorRows.length > 0) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '에러 데이터를 제외하고 저장하시겠습니까?',
          type: 'info',
          confirmCallback: () => this.persistUpload(normalRows, complete),
          cancelCallback: () => {},
        });
      } else {
        this.persistUpload(normalRows, complete);
      }
    },
    persistUpload(rows, complete) {
      this.isSaving = true;
      this.$http.url = complete ? this.completeExcelUrl : this.saveExcelUrl;
      this.$http.type = complete ? 'POST' : 'PUT';
      this.$http.param = {
        mdmMaterialRegulatoryInfoExcelUploadId: this.param.mdmMaterialRegulatoryInfoExcelUploadId || '',
        statusCd: 'CEUS000005',
        rows,
        regUserId: this.$store.getters.user.userId,
        chgUserId: this.$store.getters.user.userId,
      };
      this.$http.request(
        (_result) => {
          const uploadId = _result.data.mdmMaterialRegulatoryInfoExcelUploadId || '';
          this.$emit('emitStep', { name: 'keySetting', param: uploadId });
          if (complete) {
            this.$emit('emitStep', {
              name: 'currentStep',
              param: {
                mdmMaterialRegulatoryInfoExcelUploadId: uploadId,
                statusCd: 'CEUS000005',
              },
            });
          }
          window.getApp.$emit('ALERT', {
            title: '안내',
            message: complete ? '엑셀 업로드를 완료하였습니다.' : '저장하였습니다.',
            type: 'success',
          });
          this.isSaving = false;
        },
        () => {
          this.isSaving = false;
        }
      );
    },
    /**
     * 업로드 현황 메시지 설정
     */
    setUploadMessage() {
      const rows = this.excelUploadInfo.data[0] || [];
      const errorRows = this.$_.filter(rows, (item) => item.error_message);
      const normalRows = this.$_.filter(rows, (item) => !item.error_message);
      this.isError = errorRows.length > 0;
      this.errorDataCheck = errorRows.length > 0;

      // 정상 행 중 CAS No.는 있지만 기존 mdm_chem과 매칭되지 않은(=신규 등록 예정) 물질만, CAS No. 기준 중복 제거
      const newChemicalRows = this.$_.uniqBy(
        this.$_.filter(
          normalRows,
          (item) => (Boolean(item.casNo) && !item.mdmChemId) || item.newChemFlag === 'Y'
        ),
        (item) => item.casNo
      );

      let message =
        '<b>✅ Sheet 명</b> : ' + (this.sheetNames[0] || '') + '\n' +
        ' <b>총 데이터 수</b> : ' + rows.length + '\n' +
        ' <b>- 문제 <font color="#8BC34A">없는</font> 데이터 수</b> : ' + normalRows.length + '\n' +
        ' <b>- 문제 <font color="#F44336">있는</font> 데이터 수</b> : ' + errorRows.length + '\n';

      if (newChemicalRows.length > 0) {
        message += ' <b style="line-height: 3em">화학물질 신규등록 </b> : ' + newChemicalRows.length + '건\n';
      }

      this.uploadMessage = message;
    },
    /**
     * 업로드 데이터 초기화
     */
    clearUploadData() {
      this.isError = false;
      this.errorDataCheck = false;
      this.uploadMessage = '';
      this.regulDbUpload.details = [];
      this.excelUploadInfo.data = [];
    },
    /**
     * 업로드 파일 삭제
     */
    deleteFile() {
      // 다음 단계 이후에는 파일 삭제 불가
      if (!this.excelEditable) return;
      this.clearUploadData();
      this.$refs.excelUpload.reset();
      this.$refs.excelUpload.removeQueuedFiles();
    },
    /**
     * 엑셀 시트에 따른 테이블 데이터 삭제
     */
    removeData(idx) {
      // 다음 단계 이후에는 제외 불가
      if (!this.excelEditable) return;
      const selectData = this.$refs.excelUploadTable.selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내',
          message: '선택된 항목이 없습니다.',
          type: 'warning',
        });
      } else {
        this.$_.forEach(selectData, (item) => {
          this.excelUploadInfo.data[idx] = this.$_.reject(this.excelUploadInfo.data[idx], (gridItem) => {
            return gridItem[this.excelUploadInfo.rowKeys[idx]] === item[this.excelUploadInfo.rowKeys[idx]];
          });
        });
        this.$refs.excelUploadTable.selected = [];
        this.regulDbUpload.details = this.excelUploadInfo.data[0] || [];
        this.setUploadMessage();
      }
    },
    /**
     * 에러 메세지에 따라 행 색상 변경
     */
    setTrClass(_props) {
      if (_props.row.error_message) return 'bg-orange-5';
      // newChemFlag: 완료 처리로 실제 mdm_chem에 신규 등록된 뒤에도(재조회 이후에도) 계속 유지되는 표시
      // casNo && !mdmChemId: 완료 전(검증 단계) 미리보기 표시
      if (_props.row.newChemFlag === 'Y' || (_props.row.casNo && !_props.row.mdmChemId)) {
        return 'bg-orange-1';
      }
      return '';
    },
    /**
     * 에러 확인/신규 물질 필터에 따라 표시할 행 목록
     */
    filteredRows(idx) {
      const rows = this.excelUploadInfo.data[idx] || [];
      return rows.filter(
        (data) =>
          (!this.errorDataCheck || data.error_message) &&
          (!this.newChemOnly || (Boolean(data.casNo) && !data.mdmChemId) || data.newChemFlag === 'Y')
      );
    },
    /**
     * 엑셀 양식 다운로드
     */
    downTemplate() {
      this.$http.url = this.templateExcelFileUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        taskClassCd: encrypt(this.excelUploadInfo.taskClassCd),
      };
      this.$http.request((_result) => {
        const fileDecInfo = fileDownDecrypt(_result.data);
        if (fileDecInfo.id === this.excelUploadInfo.taskClassCd) {
          const blob = this.$comm.base64ToBlob(fileDecInfo.bytes, this.fileInfo.fileExt);
          const nav = window.navigator;
          if (nav && nav.msSaveOrOpenBlob) {
            nav.msSaveOrOpenBlob(blob, this.fileInfo.oriFileNm);
          } else {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = this.fileInfo.oriFileNm;
            link.click();
          }
        } else {
          window.getApp.$emit('ALERT', {
            title: '안내',
            message: '잘못된 정보입니다.',
            type: 'error',
          });
        }
      });
    },
  },
};
</script>
